@if (isDurationUnit) {
    <div
        class="inline-flex w-max max-w-full flex-nowrap items-center justify-center gap-1"
        dir="ltr"
    >
        @if (units === 'hour') {
            <input
                type="number"
                min="0"
                step="1"
                class="hide-arrows box-border w-12 shrink-0 px-2 py-1.5 text-center text-sm tabular-nums"
                [disabled]="disabled"
                [(ngModel)]="hours"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onDurationPartChange()"
                (blur)="handleBlur()"
            />
            <span class="select-none text-slate-400">:</span>
        }
        <input
            type="number"
            min="0"
            step="1"
            class="hide-arrows box-border w-12 shrink-0 px-2 py-1.5 text-center text-sm tabular-nums"
            [disabled]="disabled"
            [(ngModel)]="minutes"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onDurationPartChange()"
            (blur)="handleBlur()"
        />
        <span class="select-none text-slate-400">:</span>
        <input
            type="number"
            min="0"
            step="1"
            class="hide-arrows box-border w-12 shrink-0 px-2 py-1.5 text-center text-sm tabular-nums"
            [disabled]="disabled"
            [(ngModel)]="seconds"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onDurationPartChange()"
            (blur)="handleBlur()"
        />
    </div>
} @else {
    <input
        dir="ltr"
        type="text"
        class="w-full text-center"
        [disabled]="disabled"
        [ngModel]="displayValue"
        (ngModelChange)="onNumericChange($event)"
        [ngModelOptions]="{ standalone: true }"
        (blur)="handleBlur()"
    />
}
